import type { Crepe } from '@milkdown/crepe';
import type { useNodeViewFactory } from '@prosemirror-adapter/react';

import { attachmentConfig, type AttachmentConfig } from './attachmentUpload';
import { AttachmentSlashMenuItems, type SlashMenuItemConfig } from './slash-items';
import { configureAttachmentNodeView } from './node-view';
import type { MediaUploadHandler } from '../../types';

export interface ConfigureAttachmentOptions {
  nodeViewFactory: ReturnType<typeof useNodeViewFactory>;
  /** Optional callback to upload file attachments. If not provided, uses blob URLs. */
  onUploadFile?: MediaUploadHandler;
}

/** Minimal interface for slash menu group returned by builder.addGroup() */
interface SlashMenuGroup {
  addItem: (key: string, item: SlashMenuItemConfig) => SlashMenuGroup;
}

/** Registers attachment NodeView and upload config for slash menu. */
export function configureAttachment(crepe: Crepe, { nodeViewFactory, onUploadFile }: ConfigureAttachmentOptions): void {
  crepe.editor.config((ctx) => configureAttachmentNodeView(ctx, nodeViewFactory));

  if (onUploadFile) {
    crepe.editor.config((ctx) => {
      ctx.set(attachmentConfig.key, { onUploadFile });
    });
  }

  crepe.editor.use(attachmentConfig);
}

export function configureAttachmentSlashMenu(group: SlashMenuGroup): void {
  group.addItem('attachment', AttachmentSlashMenuItems.file());
}

export { AttachmentNodeView, configureAttachmentNodeView } from './node-view';
export type { AttachmentConfig };
